import { Injectable } from '@angular/core';

export const FIRST_HOVER_DELAY_MS = 200;
export const WARM_WINDOW_MS = 300;

@Injectable({ providedIn: 'root' })
export class HoverWarmSession {
    private readonly visibleOwners = new Set<object>();
    private warmUntil = 0;

    public isWarm(): boolean {
        return this.visibleOwners.size > 0 || Date.now() < this.warmUntil;
    }

    public hoverDelay(coldDelayMs = FIRST_HOVER_DELAY_MS): number {
        return this.isWarm() ? 0 : coldDelayMs;
    }

    public opened(owner: object): void {
        this.visibleOwners.add(owner);
        this.warmUntil = 0;
    }

    public closed(owner: object): void {
        if (!this.visibleOwners.delete(owner)) return;
        if (this.visibleOwners.size === 0) {
            this.warmUntil = Date.now() + WARM_WINDOW_MS;
        }
    }
}
